import * as React from 'react';
import styled from "@emotion/styled";

import {
    FormControl,
    FormControlLabel,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    TextField
} from "@mui/material";
import {VisibilityOutlined, VisibilityOffOutlined} from "@mui/icons-material";
import SwitchToggle from "../../../components/styledcomponents/SwitchToggle";
import UploadProfileImage from "../../../components/utils/UploadProfileImage";

const PersonalSettingsDrawer = () => {

    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return (
        <div>
            <UserContainer>
                <SubTitle>Benutzer</SubTitle>
                <UploadProfileImage />
            </UserContainer>

            <InputsContainer>
                <SubTitle>Allgemein</SubTitle>
                <TextField id="outlined-basic" label="Vor- und Nachname" variant="outlined" className="input" fullWidth />
                <TextField id="outlined-basic" label="E-Mail Adresse" variant="outlined" className="input" fullWidth/>
                <div className="save">Speichern</div>
            </InputsContainer>

            <InputsContainer>
                <SubTitle>Passwort</SubTitle>
                <FormControl variant="outlined" sx={{marginTop: '24px'}}>
                    <InputLabelCustom htmlFor="outlined-adornment-password">Aktuelles Passwort</InputLabelCustom>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={showPassword ? 'text' : 'password'}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOffOutlined style={{fill: '#1C1B1F'}} /> : <VisibilityOutlined style={{fill: '#1C1B1F'}} />}
                                </IconButton>
                            </InputAdornment>
                        }
                        label="Password"
                    />
                </FormControl>
                <FormControl variant="outlined" sx={{marginTop: '24px'}}>
                    <InputLabelCustom htmlFor="outlined-adornment-password">Neues Passwort</InputLabelCustom>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={showPassword ? 'text' : 'password'}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOffOutlined style={{fill: '#1C1B1F'}} /> : <VisibilityOutlined style={{fill: '#1C1B1F'}} />}
                                </IconButton>
                            </InputAdornment>
                        }
                        label="Password"
                    />
                </FormControl>
                <div className="save">Speichern</div>
            </InputsContainer>

            <NotificationsContainer>
                <SubTitle>Benachrichtigungen</SubTitle>
                <div className="settingItem">
                    <div className="settingText">A dialog is a type of modal window that appears</div>
                    <FormControlLabel
                        control={<SwitchToggle sx={{ m: 1, marginRight: '0px' }} defaultChecked />}
                        label=""
                        style={{marginRight: '0px'}}
                    />
                </div>
                <div className="settingItem">
                    <div className="settingText">A dialog is a type of modal window that appears</div>
                    <FormControlLabel
                        control={<SwitchToggle sx={{ m: 1, marginRight: '0px' }} defaultChecked />}
                        label=""
                        style={{marginRight: '0px'}}
                    />
                </div>
                <div className="settingItem">
                    <div className="settingText">A dialog is a type of modal window that appears</div>
                    <FormControlLabel
                        control={<SwitchToggle sx={{ m: 1, marginRight: '0px' }} defaultChecked />}
                        label=""
                        style={{marginRight: '0px'}}
                    />
                </div>
            </NotificationsContainer>
        </div>
    );

};

export default PersonalSettingsDrawer;

const InputLabelCustom = styled(InputLabel)`
  background: white;
  padding: 2px 5px;
`;

const SubTitle = styled.div`
  color: var(--M3-sys-light-on-surface, #1D1B20);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
`;

const UserContainer = styled.div`
  margin-top: 37px;
  margin-left: 20px;
  margin-right: 20px;
`;

const InputsContainer = styled.div`
  margin-top: 37px;
  margin-left: 24px;
  margin-right: 24px;
  display: flex;
  flex-direction: column;
  
  .input {
    margin-top: 24px;
    color: #1D1B20;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.02px;
  }
  
  .save {
    margin-top: 12px;
    display: flex;
    padding: 10px 0;
    align-items: start;
    gap: 8px;
    flex: 1 0 0;
    align-self: stretch;
    color: #3F6AC4;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.1px;
    cursor: pointer;
  }
`;

const NotificationsContainer = styled.div`
  margin: 30px 24px;
  display: flex;
  flex-direction: column;

  .settingItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
  }

  .settingText {
    color: #1D1B20;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.02px;
  }
`;